const appConfig = {
    apiPrefix: 'https://kizad.ahlamkom.net',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig